"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var colors = _interopRequireWildcard(require("./colors"));

var _StepGroup = _interopRequireDefault(require("./StepGroup"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Stepper =
/*#__PURE__*/
function (_Component) {
  _inherits(Stepper, _Component);

  function Stepper() {
    _classCallCheck(this, Stepper);

    return _possibleConstructorReturn(this, _getPrototypeOf(Stepper).apply(this, arguments));
  }

  _createClass(Stepper, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          activeStep = _this$props.activeStep,
          bsStyle = _this$props.bsStyle,
          small = _this$props.small,
          color = _this$props.color,
          partial = _this$props.partial,
          vertical = _this$props.vertical;
      var activeColor = color || (0, _utils.mapBsStyleToColor)(bsStyle, {
        fallback: colors.success.base
      });

      var totalSteps = _react.Children.count(children);

      var steps = _react.Children.map(children, function (step, index) {
        var last = index === totalSteps - 1;
        var controlProps = {
          index: index,
          activeColor: activeColor,
          small: small,
          vertical: vertical
        };
        var overrideBsStyle = step.props.overrideBsStyle; // Extended from https://github.com/callemall/material-ui/blob/master/src/Stepper/Stepper.js

        var activeSteps = activeStep.toString().split('.');
        var activeIndex = parseInt(activeSteps[0], 10);
        controlProps.activeSubStep = activeSteps[1] ? parseInt(activeSteps[1], 10) : undefined;
        var connectorColor = index >= activeIndex ? colors.alloy : overrideBsStyle ? (0, _utils.mapBsStyleToColor)(overrideBsStyle, {
          fallback: colors.alloy
        }) : colors.success.base;
        controlProps.connectorColor = connectorColor;
        var connector = vertical ? _react["default"].createElement("div", {
          style: {
            flex: '1 1 auto',
            borderRight: "2px solid ".concat(connectorColor),
            paddingRight: small ? '6px' : '9px',
            margin: '4px 0',
            flexDirection: 'column'
          }
        }) : _react["default"].createElement("div", {
          style: {
            flex: '1 1 auto',
            borderTop: "2px solid ".concat(connectorColor),
            marginTop: small ? '6px' : '9px'
          }
        });

        if (activeIndex === index) {
          controlProps.active = true;
          controlProps.partial = partial;
        } else if (activeIndex > index) {
          controlProps.completed = true;
        } else if (activeIndex < index) {// do we want to add anything here?
        }

        return [_react["default"].cloneElement(step, _objectSpread({}, controlProps, step.props, {
          index: controlProps.index
        })), !last && !(step.type === _StepGroup["default"]) && connector];
      });

      var stepperStyle = vertical ? {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        height: '100%',
        width: 'fit-content'
      } : {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '14px 0 0',
        marginBottom: '30px'
      };
      return _react["default"].createElement("div", {
        className: "stepper",
        style: stepperStyle
      }, steps);
    }
  }]);

  return Stepper;
}(_react.Component);

exports["default"] = Stepper;
Stepper.propTypes = {
  children: _propTypes["default"].arrayOf(_propTypes["default"].node),
  activeStep: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  partial: _propTypes["default"].bool,
  bsStyle: _propTypes["default"].string,
  color: _propTypes["default"].string,
  small: _propTypes["default"].bool,
  vertical: _propTypes["default"].bool
};
Stepper.defaultProps = {
  bsStyle: 'success',
  small: false,
  vertical: false
};